

export function scrollToTop(element=document.body){
    document.body.style.overflow = "auto";
    document.body.scrollTo(0,0);
    setTimeout(() => {
        document.body.style.overflow = "initial";
    }, 500);
}